import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import useInactivity from "../hooks/useInactivity";
import { useEffect, useState } from "react";

export const CourseFile = ({ lesson, setControls }) => {
    const supportedFileTypes = ["pdf", "ppt", "pptx", "doc", "docx"];
    const { isInactive, isTabInactive } = useInactivity();
    const timer = lesson?.timer || 0;
    const [countdown, setCountdown] = useState(timer);

    useEffect(() => {
        if (isInactive || isTabInactive) {
            console.log("User is inactive");
        }
    }, [isInactive, isTabInactive]);

    useEffect(() => {
        if (countdown > 0) {
            setControls({state: 'counting'})

            const intervalId = setInterval(() => {
                setCountdown((prevCountdown) => prevCountdown - 1);
            }, 1000);

            return () => clearInterval(intervalId);
        } else if (countdown === 0) {
            setControls({
              state: 'ended'
            });
        }
    }, [countdown, setControls]);

    const getFileType = (fileName) => {
        const extension = fileName.split(".").pop()?.toLowerCase();
        return supportedFileTypes.includes(extension) ? extension : "default";
    };

    return (
        <div>
            <h2>{lesson?.title}</h2>
            {/* {timer > 0 && <p>Time remaining: {countdown} seconds</p>} */}
            {["ppt", "pptx"].includes(getFileType(lesson?.file.data.attributes.name)) ? (
                <iframe
                    title={lesson?.title}
                    src={`https://view.officeapps.live.com/op/embed.aspx?src=${lesson?.file.data.attributes.url}&wdHideToolbar=1&wdHideHeaders=1&wdHideNavigationPane=1&wdNoActions=1&wdNoExpand=1`}
                    width="100%"
                    height="600px"
                    frameBorder="0"
                    sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
                ></iframe>
            ) : (
                <DocViewer
                    style={{ height: "800px" }}
                    prefetchMethod="GET"
                    config={{
                        header: {
                            disableFileName: true,
                        },
                        disableDownload: true, // Ensure downloads are disabled
                    }}
                    documents={[
                        {
                            uri: lesson?.file.data.attributes.url,
                        },
                    ]}
                    pluginRenderers={DocViewerRenderers}
                />
            )}
        </div>
    );
};
